import { GuestyMessageHistory } from './guesty-message-history';

// Re-export the component from the new folder structure
export default GuestyMessageHistory;
